import { render, staticRenderFns } from "./OrdersV3.vue?vue&type=template&id=23fc7b83&"
import script from "./OrdersV3.vue?vue&type=script&lang=js&"
export * from "./OrdersV3.vue?vue&type=script&lang=js&"
import style0 from "./OrdersV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports